<template>
  <div class="px-16 md:px-0">
    <AffiliateFormFields
      v-if="!isConfirmed"
      :isLoading="isLoading"
      @submit="onSubmit"
      @cancel="$emit('cancel')"
    />

    <AffiliateApplicationReceived
      v-else
      @contact="onContactSupport"
      @cancel="$emit('cancel')"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import AffiliateApplicationReceived from '../../AffiliateApplicationReceived/AffiliateApplicationReceived.vue'
import AffiliateFormFields from './AffiliateFormFields/AffiliateFormFields.vue'
import type { Emits } from './AffiliateForm.types'
import type { Form } from './AffiliateFormFields/AffiliateFormFields.types'
import { useCreateAffiliateApplicationMutation } from '@/modules/Affiliate/requests/mutations'
import useSupportStore from '@/modules/Support/store'

const emit = defineEmits<Emits>()

const { mutateAsync, isLoading } = useCreateAffiliateApplicationMutation()

const isConfirmed = ref(false)

async function onSubmit(values: Form) {
  const { phone, ...rest } = values
  await mutateAsync({
    ...rest,
    phoneNumber: `${phone.code}${phone.number}`,
  })

  isConfirmed.value = true

  emit('confirm')
}

const supportStore = useSupportStore()
function onContactSupport() {
  emit('cancel')
  supportStore.toggleIsOpen(true)
}
</script>
